
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const NagwaDam=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Nagwa and Silhat Dams</h1>
           <p className="sub-heading">An early engineering marvel built since 1918,the best Picnic Spot, also known as Mini Ooty</p>
         </div>
         <div className="description">
         Nestled amidst the scenic landscapes of Sonbhadra, Nagwa and Silhat Dams are tranquil retreats offering stunning views of serene waters surrounded by lush greenery. These dams serve as vital water reservoirs while doubling as picturesque destinations for picnics, bird-watching, and relaxation.

Nagwa Dam, located near the Vindhya Range, is an engineering marvel set against a backdrop of hills and forests. Silhat Dam, on the other hand, enchants visitors with its peaceful ambiance and the mesmerizing reflection of nature on its calm waters. Both spots are ideal for those looking to unwind and reconnect with nature, away from the bustling city life. Whether you're a local explorer or a tourist, Nagwa and Silhat Dams promise a refreshing experience in the heart of Sonbhadra's untouched beauty.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/4.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/6.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/7.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/8.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Nagwa Dam and Silhat Dam/5.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
          
         </div>
   
         <BookSection />
       </div>
     );
};